module.exports = __webpack_public_path__ + "img/game3.2.647ac8ae.png";